import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import CreateTokenView from "../views/CreateTokenView.vue";
import CouponListView from "../views/CouponListView.vue";
import CouponUsedListView from "../views/CouponUsedListView.vue";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginView,
    meta: {
      title: "ログイン",
    },
  },
  {
    path: "/createCoupon",
    name: "createCoupon",
    component: CreateTokenView,
    meta: {
      title: "クーポン発行",
    },
  },
  {
    path: "/couponList",
    name: "couponList",
    component: CouponListView,
    meta: {
      title: "クーポン一覧",
    },
  },
  {
    path: "/couponUsedList",
    name: "couponUsedList",
    component: CouponUsedListView,
    meta: {
      title: "使用済一覧",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = getAuth();
  var firebaseUser = null;
  await new Promise((resolve) => {
    onAuthStateChanged(auth, (user) => {
      firebaseUser = user;
      resolve();
    });
  });
  if (firebaseUser) {
    if (to.name == "login") {
      next({ name: "createCoupon" });
    } else {
      next();
    }
  } else {
    if (to.name == "login") {
      next();
    } else {
      next({ name: "login" });
    }
  }
});

export default router;
